import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get verify user */
export const getVerifyUser = async () => {
  const res = await get(`/enterprise-api/verify_enterprise`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetVerifyUserToken = (onSuccess: any, onError: any, enable = false) => {
  return useQuery('user-verify', getVerifyUser, {
    refetchOnWindowFocus: false,
    enabled: enable,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetVerifyUserToken;
